module.exports = __webpack_public_path__ + "img/otp.a97e742e.png";